import React from 'react';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import Input from 'components/form/Input';
import Radio from 'components/form/Radio';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import useSnack from 'hooks/useSnack';
import { useMutation } from '@apollo/react-hooks';
import { UPDATE_STUDENT_PROFILE } from 'graphql/student/Profile';
import extend from 'lodash/extend';
import { Box } from '@material-ui/core';

const FormItem = Form.FormItem;

const COUNSELOR = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
  { label: 'Other', value: 'other' },
];

const SIBLINGS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

const HighSchoolForm = ({
  college_info,
  user,
  saveText,
  disableCard,
  isSkip,
  onSkip,
  form: { getFieldDecorator, validateFields, getFieldValue },
  step,
  history,
  editable,
}) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_STUDENT_PROFILE);

  const onSubmit = () => {
    return validateFields().then((values) => {
      if (values.has_sibling_did_admission_process !== 'yes') {
        values.sibling_admission_process = null;
      }
      if (values.have_worked_with_counselor !== 'other') {
        values.have_worked_with_counselor_other = null;
      }
      values = { ...values, completed: true };
      return update({
        variables: {
          id: user.id,
          input: {
            college_info: extend(college_info, values),
          },
        },
      }).then(
        () => {
          snack.success('Profile saved');
          step && history.push(`/onboarding/${step + 1}`);
        },
        (e) => {
          snack.error(e.message);
        },
      );
    });
  };

  const haveWorked =
    getFieldValue('have_worked_with_counselor') ||
    college_info?.have_worked_with_counselor;
  const haveSibling =
    getFieldValue('has_sibling_did_admission_process') ||
    college_info?.has_sibling_did_admission_process;
  return (
    <Card className={classes.card} component={disableCard && 'span'}>
      <CardContent className={classes.cardContent}>
        <Typography variant="h5">College Experience</Typography>
        <Box maxWidth={500} width="100%" marginTop={5}>
          <Form>
            <FormItem>
              {getFieldDecorator('have_worked_with_counselor', {
                initialValue: college_info?.have_worked_with_counselor,
              })(
                <Radio
                  disabled={!editable}
                  size="small"
                  options={COUNSELOR}
                  label="Have you ever worked with a college counselor before?"
                />,
              )}
            </FormItem>
            {haveWorked === 'other' && (
              <FormItem>
                {getFieldDecorator('have_worked_with_counselor_other', {
                  initialValue: college_info?.have_worked_with_counselor_other,
                  rules: [{ required: true, message: 'Please enter answer' }],
                })(
                  <Input
                    disabled={!editable}
                    placeholder="Enter your answer"
                  />,
                )}
              </FormItem>
            )}
            <FormItem>
              {getFieldDecorator('has_sibling_did_admission_process', {
                initialValue: college_info?.has_sibling_did_admission_process,
              })(
                <Radio
                  disabled={!editable}
                  size="small"
                  label="Do you have any siblings who have been through the college admissions process?"
                  options={SIBLINGS}
                />,
              )}
            </FormItem>
            {haveSibling === 'yes' && (
              <FormItem>
                {getFieldDecorator('sibling_admission_process', {
                  initialValue: college_info?.sibling_admission_process,
                  rules: [{ required: true, message: 'Please enter answer' }],
                })(
                  <Input
                    disabled={!editable}
                    label="Which college(s) did they attend?"
                    placeholder="Enter your answer"
                  />,
                )}
              </FormItem>
            )}
          </Form>
        </Box>
      </CardContent>
      {!disableCard && <Divider />}
      <CardContent className={classes.footer}>
        <Box display="flex" justifyContent="center">
          {isSkip && (
            <div style={{ marginRight: 24 }}>
              <Button size="large" onClick={onSkip} variant="outlined">
                Skip
              </Button>
            </div>
          )}
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={!editable}
          >
            {saveText || 'Save'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Form.create()(HighSchoolForm);
